import { useCallback, useEffect } from 'react';
import { useMedplum, useMedplumProfile } from '@medplum/react';
import { ARKON } from '@consts/systems.consts';

// -----------------------------------------------------------------------------
export function useUserPreferences(shouldLoad = false) {
  const medplum = useMedplum();
  const profile = useMedplumProfile();

  // ---------------------------------------------------------------------------
  useEffect(() => {
    if (!shouldLoad) {
      return;
    }

    if (profile?.extension) {
      const extension = profile.extension.find((ext) => ext.url === ARKON.BASE);
      if (extension?.valueString) {
        try {
          const storedPreferences = JSON.parse(
            JSON.parse(extension.valueString)
          ) as Record<string, string>;

          Object.entries(storedPreferences).forEach(([key, value]) => {
            localStorage.setItem(key, value);
          });
        } catch (error) {
          console.error(
            'Failed to parse preferences from FHIR profile:',
            error
          );
        }
      }
    }
  }, [profile, shouldLoad]);

  // ---------------------------------------------------------------------------
  const savePreferences = useCallback(() => {
    const preferences: Record<string, string> = {};

    Object.keys(localStorage).forEach((key) => {
      if (key !== 'logins' && key !== 'activeLogin') {
        const value = localStorage.getItem(key);
        if (value !== null) {
          preferences[key] = value;
        }
      }
    });

    if (Object.keys(preferences).length > 0 && profile) {
      const jsonString = JSON.stringify(preferences);

      const existingExtension = profile.extension?.find(
        (ext) => ext.url === ARKON.BASE
      );

      if (existingExtension) {
        existingExtension.valueString = JSON.stringify(jsonString);

        medplum.updateResource(profile).catch(console.error);
      } else {
        const newExtension = {
          url: ARKON.BASE,
          valueString: JSON.stringify(jsonString),
        };

        const updatedProfile = {
          ...profile,
          extension: [...(profile.extension || []), newExtension],
        };

        medplum.updateResource(updatedProfile).catch(console.error);
      }
    }
  }, [medplum, profile]);

  // ---------------------------------------------------------------------------
  return { savePreferences };
}
